const currentEnv = (...env: Array<'prod' | 'demo' | 'stg' | 'qa' | 'dev' | 'prototype'>) =>
  env.includes(import.meta.env.MODE as (typeof env)[0]);

export default {
  ENV: {
    DEV: currentEnv('dev'),
    PROD: currentEnv('prod'),
    STG: currentEnv('stg'),
    QA: currentEnv('qa'),
    DEMO: currentEnv('demo'),
    PROTOTYPE: currentEnv('prototype'),
  },
  FEATURE_FLAGS: {
    DISABLE_PLAYER_TRANSCRIPTION: false,
    DISABLE_SEQUENTIAL_VIEWING: currentEnv('prod', 'demo'),
    DISABLE_USER_SETTINGS: currentEnv('prod', 'demo'),
    DISABLE_SUBCATEGORIES: currentEnv('prod', 'demo'),
    HIDE_GO_CORE: currentEnv('demo'),
  },
  FIELD_LIMITS: {
    USER: {
      FIRST_NAME: 64,
      LAST_NAME: 64,
    },
  },
} as const;
